import { Loader2 } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { TranscriptViewToggleProps } from '@/types';
import { TranscriptsView } from '@/enums';
import useTranslation from '@/hooks/useTranslation';

function TranscriptsViewToggle({
  activeView,
  onViewChange,
  completedCount,
  incompleteCount,
  screenedOutCount,
  isLoading = false,
  showIncompleteToggle = true,
  showScreenedOutToggle = true,
}: TranscriptViewToggleProps) {
  const { lang } = useTranslation();

  const isCompletedLoading = isLoading && activeView === TranscriptsView.COMPLETED;
  const isIncompleteLoading = isLoading && activeView === TranscriptsView.INCOMPLETE;
  const isScreenedOutLoading = isLoading && activeView === TranscriptsView.SCREENED_OUT;

  return (
    <Tabs
      value={activeView}
      onValueChange={(value) => onViewChange(value as TranscriptsView)}
    >
      <TabsList>
        <TabsTrigger value={TranscriptsView.COMPLETED} disabled={isLoading}>
          <span className="capitalize mr-1">{lang.get(`msg.${TranscriptsView.COMPLETED}`)}</span>
          {isCompletedLoading ? (
            <Loader2 className="inline h-4 w-4 animate-spin" />
          ) : (
            `(${completedCount})`
          )}
        </TabsTrigger>
        {showIncompleteToggle && (
          <TabsTrigger value={TranscriptsView.INCOMPLETE} disabled={isLoading}>
            <span className="capitalize mr-1">{lang.get(`msg.${TranscriptsView.INCOMPLETE}`)}</span>
            {isIncompleteLoading ? (
              <Loader2 className="inline h-4 w-4 animate-spin" />
            ) : (
              `(${incompleteCount})`
            )}
          </TabsTrigger>
        )}
        {showScreenedOutToggle && (
          <TabsTrigger value={TranscriptsView.SCREENED_OUT} disabled={isLoading}>
            <span className="capitalize mr-1">
              {lang.get(`msg.${TranscriptsView.SCREENED_OUT}`)}
            </span>
            {isScreenedOutLoading ? (
              <Loader2 className="inline h-4 w-4 animate-spin" />
            ) : (
              `(${screenedOutCount})`
            )}
          </TabsTrigger>
        )}
      </TabsList>
    </Tabs>
  );
}

export default TranscriptsViewToggle;
